export default __webpack_public_path__ + "static/media/xd_logo.e01916ff.png";